var path = '/common/formly/inputs/tpl/phone-validate.html';
var html = "<input type=input class=form-control ng-model=model[options.key] ui-options=options.ngModelAttrs /> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/common/formly/inputs/tpl/phone-validate.html
// module id = 1765
// module chunks = 1